<template>
    <b-button variant="outline-primary" :href="href">
        <font-awesome-icon :icon="['fas', 'download']" />
    </b-button>
</template>

<script>
export default {
    computed: {
        href() {
            return this.params.data?.download_link;
        },
    },
};
</script>

<style>
</style>